import type { InvoiceHistoryRecord } from '~/api/invoices/types';
import type { IconName } from '~/components';

export const historyRecordIcons = {
  Created: 'Edit',
  Finalized: 'PersonCheck',
  LockedByUser: 'Edit',
  Approved: 'Check',
  EmailApprovedAndSent: 'Mail',
  Expired: 'HourglassBottom',
  EmailPaymentReminder: 'Mail',
  PartiallyPaid: 'Payments',
  PaidByClient: 'Payments',
  PaidByCreativeShelter: 'Payments',
  Credited: 'CreditNote',
  PeppolCoSent: 'Peppol',
  PeppolCoDelivered: 'Peppol',
  PeppolCoAccepted: 'Peppol',
  PeppolCoRefused: 'Peppol',
  PeppolFcSent: 'Peppol',
  PeppolFcDelivered: 'Peppol',
  PeppolFcAccepted: 'Peppol',
  PeppolFcRefused: 'Peppol',
  FollowUpStarted: 'Flag',
  FollowUpManualReminder: 'Mail',
  FollowUpLastManualReminder: 'Mail',
  FollowUpContactClientByPhone: 'Person',
  FollowUpFormalNoticeSent: 'Gavel',
  FollowUpInvoiceSentToLawyer: 'Gavel',
  FollowUpInvoiceSentToBailiff: 'Gavel',
  FollowUpRemark: 'ChatBubble',
  CreditNoteApproved: 'Check',
  CreditNoteEmailApprovedAndSent: 'Mail',
} as const satisfies Record<InvoiceHistoryRecord['type'], IconName>;

export const upcomingMilestones = ['Approved', 'PaidByClient', 'PaidByCreativeShelter'] as const satisfies InvoiceHistoryRecord['type'][];

export const followUpStepTypes = [
  'FollowUpStarted',
  'FollowUpManualReminder',
  'FollowUpContactClientByPhone',
  'FollowUpLastManualReminder',
  'FollowUpFormalNoticeSent',
  'FollowUpInvoiceSentToLawyer',
  'FollowUpInvoiceSentToBailiff',
] as const satisfies InvoiceHistoryRecord['type'][];
